{
   "_vars": {
      "{name}": "{name}",
      "{type}": "{type}"
   },
   "actions": {
      "add": "Ajouter | Ajouter @.lower:{'_vars.{name}'} | {name} ajouté",
      "add-type": "Ajouter @.lower:{'_vars.{type}'}",
      "download": "Télécharger",
      "view": "Voir",
      "apply": "Appliquer",
      "bug-report": "Rapportez une erreur",
      "cancel": "Annuler | Annuler",
      "change": "Enregistrer | Ajuster {name}",
      "change-type": "Ajuster {type}",
      "clear": "Vider",
      "clear-direct-search": "Effacer la recherche directe",
      "click-here": "Cliquez ici",
      "close": "Fermer",
      "confirm": "Confirmer",
      "copy": "Copier",
      "create": "créer {item}",
      "delete": "Supprimer | Supprimer",
      "delete-hard": "Supprimer définitivement",
      "export": "Exporter | Exporter {type}",
      "manage-organisation": "Gérer mon organisation",
      "no-batches": "Pas de processus en cours",
      "notifications": "Notifications",
      "notion-page": "Manuel",
      "refresh": "Rafraîchir la page",
      "remove": "Supprimer | \nEffacer tout",
      "remove-styling": "Supprimer le style",
      "reset": "Réinitialiser",
      "reset-filters": "Réinitialiser les filtres",
      "running-batches": "1 processus en cours | \n{montant} processus en cours d'exécution",
      "save": "Sauvegarder",
      "search": "Recherche | Rechercher",
      "select": "Sélectionner",
      "send": "Envoyer",
      "send-request": "Envoyer une demande",
      "settings": "Paramètres",
      "show-more": "Montre plus",
      "upload": "Télécharger | {type} télécharger",
      "print": "Imprimer",
      "validate": "Valider",
      "select-all": "Tout sélectionner",
      "retry": "Essayer à nouveau",
      "save-and-continue": "Sauver et ensuite",
      "edit": "Modifier | {name} modifié"
   },
   "app-name": "NxtMatch",
   "running-processes": {
      "title": "Processus en cours",
      "subtitle": "Travail qui nécessite encore votre attention",
      "tabs": {
         "running": "En cours",
         "completed": "Terminé",
         "failed": "Échoué"
      },
      "bulk-cv-import": "Import CV en masse",
      "batch-title": "Lot CV {date}",
      "batch-title-with-list": "Lot CV {date} – {name}",
      "uploaded": "{done} sur {total} CV chargés",
      "reviewed": "{done} sur {total} CV revus",
      "duplicates": "{done} sur {total} CV validés pour doublons",
      "continue": "Continuer",
      "cancel": "Annuler",
      "empty-running": "Pas de processus en cours",
      "empty-completed": "Pas de processus terminés",
      "empty-failed": "Pas de processus échoués",
      "just-now": "À l'instant",
      "minutes-ago": "il y a {count} min",
      "hours-ago": "il y a {count} h",
      "days-ago": "il y a {count} j"
   },
   "ai-matching": {
      "ai-matching": "AI Matching",
      "landing-title": "Trouvez les meilleurs talents avec l'IA.",
      "landing-subtitle": "Sélectionnez une offre d'emploi et l'IA analyse automatiquement votre vivier de talents. Vous obtenez une liste classée avec une explication de pourquoi chaque talent correspond.",
      "recommended": "Recommandé",
      "priority-high": "Priorité élevée",
      "feature-smart-match-title": "Matching intelligent",
      "feature-smart-match-description": "Les critères sont automatiquement extraits du texte de l'offre d'emploi.",
      "feature-explanation-title": "Explication par matching",
      "feature-explanation-description": "L'IA explique pourquoi une personne correspond ou non.",
      "feature-learns-title": "Apprend de vous",
      "feature-learns-description": "Plus vous présélectionnez, plus les suggestions deviennent pertinentes.",
      "start-first-matching": "Démarrez votre premier matching",
      "start-matching": "Démarrer le matching",
      "ready-to-match": "Offres prêtes à être matchées",
      "analyse-title": "Analyse IA de matching",
      "give-feedback": "Donner un avis",
      "feedback-title": "Donner un avis",
      "feedback-question": "Cette analyse IA était-elle correcte ?",
      "feedback-saved": "Avis enregistré",
      "feedback-suggestion-skills": "Compétences correctes",
      "feedback-suggestion-experience": "Bonne expérience",
      "feedback-suggestion-location": "Localisation ok",
      "new-matching": "+ Nouveau matching",
      "active-matchings": "Matchings actifs",
      "active-matchings-subtitle": "Cliquez sur une offre pour voir les talents trouvés.",
      "select-a-matching": "<< Sélectionner un matching",
      "found-talents": "Talents trouvés",
      "counts": "{liked} shortlist · {disliked} non retenus",
      "all-talents": "Tous les talents ({count})",
      "shortlist": "Présélection ({count})",
      "not-selected": "Non sélectionné ({count})",
      "matching-in-progress": "Le matching IA est en cours...",
      "select-a-candidate": "Sélectionnez un candidat",
      "no-preference": "Aucune préférence",
      "search-radius-from": "Rayon de recherche depuis {city}",
      "delete-matching": "Supprimer le matching",
      "delete-matching-description": "Êtes-vous sûr de vouloir supprimer ce matching ? Cette action est irréversible.",
      "matching-done": "Le matching IA est terminé. Les candidats sont disponibles.",
      "keywords": "Mots-clés",
      "keywords-placeholder": "Ex. vendeur, conseiller de vente",
      "keywords-label": "Ajoutez des compétences, technologies ou expériences spécifiques"
   },
   "call-lists": {
      "added-to-call-list": "{montant} candidat ajouté à la liste d'appels | {amount} candidats ajoutés à la liste d'appel",
      "auto-calling": "Appel automatique",
      "call-list": "Listes d'appels",
      "call-list-deleted": "La liste d'appels a été supprimée",
      "candidate-skipped": "La candidate {first_name} {last_name} a été ignorée car il/elle ne souhaite pas être contactée par téléphone.",
      "candidate-skipped-called": "Le candidat {first_name} {last_name} a été ignoré car il a déjà été contacté.",
      "candidates": {
         "delete-candidates": "Supprimer des candidats de la liste d'appel ?",
         "delete-candidates-description": "Supprimez ces candidats. Cette action est irréversible, êtes-vous sûr ?",
         "delete-candidates-from-list": "Supprimer des candidats de la liste d'appels",
         "set-handled": "Marquer comme traité",
         "set-unhandled": "Marquer comme non traité"
      },
      "delete-call-list": "Supprimer la liste d'appel ?",
      "delete-call-list-description": "Supprimez la liste d'appels {call_list}. Cette action est irréversible, êtes-vous sûr ?",
      "failed-lookups": "{amount} valeurs introuvables.",
      "import-candidates-call-list": "importer des candidats dans la liste d'appels",
      "my-call-lists": "Mes listes d'appels",
      "no-candidates-added-to-call-list": "No candidates were added to a call list!",
      "no-new-candidates-added-to-call-list": "Aucun nouveau candidat ajouté à la liste d'appel",
      "put-in-values": "Entrez des valeurs (séparées par 'entrée')",
      "saved-call-list": "Listes d'appels enregistrées",
      "zoiper-message": "N'oubliez pas d'activer l'option \"Enable incoming call handling\" dans les paramètres de Zoiper et de la désactiver après avoir appelé."
   },
   "candidates": {
      "view-candidate": "Voir le candidat",
      "able-bodied-person": "Personne valide",
      "account-number": "Numéro de compte",
      "activated-message": "Le candidat a activé son compte et gère désormais lui-même ses données personnelles. \nSi des données sont manquantes, utilisez les boutons <span style=\"color: var(--nxt-main)\"><i class=\"fa-solid fa-paper-plane\"></i> Vérifier</span>. avec les données manquantes afin que le candidat puisse compléter les données manquantes.",
      "activated-title": "Le candidat gère ses propres données",
      "add-candidate": "Ajouter un candidat",
      "add-candidate-to-pool": "Ajouter candidat au pool | Ajouter candidats au pool",
      "add-to-pool": "Ajouter au pool NxtPlan",
      "added-to-pool": "Ajouté dans NxtPlan pool",
      "approval-history": "Historique des approbations",
      "approval-state": "Statut approuvé",
      "ask-for-approval-success": "La demande d'approbation a été envoyée",
      "bic-number": "Numéro BIC",
      "birth-date": "Date de naissance",
      "board": "Board",
      "bulk-parse-cv": "Analyser les CV en lot",
      "bulk-parse-resume": "Analyser les CV en lot",
      "candidate": "Candidat | Candidats",
      "candidate-created": "Le candidat a été ajouté",
      "candidate-in-running-selected-customers": "Le candidat est déjà en cours pour l'une des entreprises sélectionnées",
      "candidate-poked": "Le candidat s'est fait piquer",
      "candidate-updated": "Le candidat a changé",
      "certificates": "Certificat | Certificats",
      "citizen-service-number": "Numéro d'identification citoyen",
      "click-to-go-to-candidate": "Cliquez ici pour voir le candidat",
      "communication-preferences": "Comment souhaitez-vous recevoir des communications concernant {type} ?",
      "competences": "Compétence | Compétences",
      "contract-type": "Type de contrat",
      "courses": "Cours | Cours",
      "current-data": "Données actuelles",
      "curriculum-vitae": "Curriculum Vitae | \nCV",
      "define-candidate-and-cv": "Définir le candidat et le CV",
      "define-candidate-and-resume": "Définir le candidat et le CV",
      "degree": "Diplôme | \nDiplômes",
      "degree-level": "Niveau de scolarité",
      "delete-candidates": "Supprimer candidat |  Supprimer candidats",
      "delete-note": "Supprimer la remarque",
      "delete-note-description": "Voulez-vous vraiment supprimer cette note ?",
      "delete-resume": "Supprimer le CV",
      "dependant": "Personnes à charge",
      "desired-function": "Fonctions souhaitées",
      "disabled-person": "Handicapé",
      "download-file": "Télécharger un fichier",
      "download-resume": "Télécharger le CV",
      "drivers-license": "Le permis de conduire",
      "edit-candidate": "Modifier le candidat",
      "educations": "Études",
      "email": "Adresse e-mail",
      "experience": "Expérience | \nExpériences",
      "export-limit-exceeded": "Impossible d'exporter plus de {amount} résultats",
      "exporting-candidates": "Exporter des candidats",
      "first-name": "Prénom",
      "found-existing-candidate-with-social-security-number": "Un candidat existant a été trouvé avec ce numéro de registre national.",
      "free-edit-text": "Courriel au candidat",
      "free-text-mail": "Texte libre",
      "frontier-worker-certificate": "Certificat de travailleur frontalier",
      "internal-employee": "Employé interne",
      "invalid-bsn-number": "Numéro de service du citoyen est invalide",
      "invalid-emails": "{amount} candidats n'ont pas d'adresse e-mail et n'ont pas été ajoutés !",
      "invalid-french-SSN": "Numéro de registre national est invalide!",
      "job-content": "Contenu de l'emploi",
      "job-function": "Fonction",
      "job-preferences": "Préférences d'emploi",
      "journey": "Journey",
      "journey-to-candidate": "Envoyer un journey au candidat",
      "journeys": "Journeys",
      "journey-dropdown-info-text": "Campagnes avec le statut \"ongoing\" sont disponibles pour envoyer.",
      "language-knowledge": "Connaissance de la langue | \nConnaissance du langage",
      "language-knowlegde": "Connaissance du langage",
      "last-active": "Dernier actif",
      "last-contact": "Dernier contact",
      "last-name": "Nom",
      "mail-candidates": "Envoyer un e-mail au candidat | \nEnvoyez un e-mail aux candidats",
      "mail-to-team": "Présenter le candidat à une équipe",
      "major": "Domaine d'étude",
      "marital-status": "État civil",
      "max-amount-candidates": "Maximal {montant} Candidat  | Maximum {amount} candidats",
      "national-registration-number": "Numéro d'inscription au répertoire",
      "nationality": "Nationalité",
      "no-activities": "Aucune activité trouvée",
      "no-approval-state": "Aucun statut d'approbation",
      "no-email": "{name} n'a pas d'adresse e-mail",
      "no-email-contact-allowed": "Le candidat ne souhaite pas être contacté par email",
      "no-journeys": "Aucun journey trouvé",
      "no-phone-contact-allowed": "Le candidat ne souhaite pas être contacté par téléphone",
      "no-sms-contact-allowed": "Le candidat ne souhaite pas être contacté par SMS",
      "no-whatsapp-contact-allowed": "Candidat ne souhaite pas être contacté par WhatsApp",
      "note-deleted": "Remarque supprimée !",
      "note-info": "Les notes sont enregistrées sous l'onglet \"activités\" dans la fiche détaillée du candidat. Vous pouvez le modifier ou supprimer par la suite.",
      "nxtform-journey": "NxtForm Journey",
      "official-address": "Domicile",
      "on-pension": "À la retraite ?",
      "open-resume": "Ouvrir CV",
      "open-video-call": "Rejoindre une réunion par appel vidéo",
      "parse-cv": "Analyser le CV | Analyser les CV",
      "parse-resume": "Analyser le CV | Analyser les CV",
      "parsed-data": "Données du document analysé",
      "partner-info": "Informations sur le partenaire",
      "partner-salary": "Salaire du partenaire",
      "payment-details": "Détails de paiement",
      "pension": "Pension",
      "phase": "Phase",
      "poke": "Poke | \nPiqué",
      "poke-candidate": "Poke le candidat",
      "pool": "Pool | Pools",
      "pools-candidate-has-been-deleted-from": "Pools d'où le candidat a été radié",
      "position-name": "Le nom de l'offre d'emploi",
      "preferences": "Préférence | \nPréférences",
      "preferred-functions": "Fonctions souhaitées",
      "preferred-job-type": "Type d'emploi souhaité",
      "preferred-job-types": "Type d'emploi",
      "profession": "Profession",
      "profile-picture": "Image de profil",
      "propose-candidate": "Suggérer un candidat",
      "referral-code": "Code de Parrainage",
      "regions": "Région de travail | Régions de travail",
      "reset-poked": "Réinitialiser poke",
      "residential-address": "Adresse de domicile",
      "resume": "CV",
      "retired-since": "Retraité depuis",
      "school": "École",
      "searched-functions": "Fonctions recherchées",
      "select-customer": "Sélectionnez entreprises",
      "send-form": "Envoyer Journey NxtForm",
      "show-candidate-details": "Afficher les détails du candidat",
      "social-security-number": "Numéro de registre national | \nRRNR belge",
      "statute": "Statut juridique",
      "tax-certificate": "Attestation fiscale",
      "work-schedules": "Horaire de travail",
      "transport-methods": "Transport",
      "upload-curriculum-vitae": "Télécharger un CV",
      "upload-id-card": "Télécharger la carte d'identité",
      "upload-profile-picture": "Télécharger photo de profil",
      "valid-from": "Valide à partir de",
      "valid-till": "Valide jusqu'à",
      "verify": "Demander des informations au candidat.\n\nLe candidat verra cela comme une tâche à faire dans l'application.",
      "verify-description": "Vous souhaitez vérifier les données du candidat.\n\n Cela créera une tâche dans l'application du candidat dans laquelle les données pourront être complétées/vérifiées.",
      "verify-title": "Vérifiez les données",
      "voluntary-amount": "Montant volontaire",
      "voluntary-percentage": "Pourcentage volontaire",
      "withholding-tax": "La retenue d'impôt",
      "work-experience": "Expériences",
      "work-experience-types": "Type",
      "job-references": "Référence d'emploi | Références d'emploi",
      "add-to-pay": "Ajouter comme employé NxtPay",
      "eid": "eID",
      "drag-eid-here": "Faites glisser l'eID dans cette case",
      "eid-has-been-loaded": "Les données eID ont été récupérées",
      "view-working-documents": "Consulter les documents de travail",
      "identity-documents": "Documents d'identité",
      "sex": "Sexe",
      "identity-card-front": "Recto de la carte d'identité",
      "identity-card-back": "Dos de la carte d'identité",
      "work-permit": "Permis de travail",
      "birth-place": "Lieu de naissance",
      "references": "Référence \nRéférences",
      "bulk-parse-resume-warning": "Un maximum de 20 fichiers peut être traité à la fois.",
      "slots": "Slots",
      "person": "Person",
      "employee": "Employee",
      "resume-upload": {
         "title": "Analyser les CV en lot V2",
         "subtitle": "Téléchargez plusieurs CV ici. Vous n'avez pas besoin d'attendre que tous les CV soient téléchargés pour commencer la révision.",
         "subtitles": {
            "load": "Téléchargez plusieurs CV ici. Vous n'avez pas besoin d'attendre que tous les CV soient téléchargés pour commencer la révision.",
            "review": "Vérifiez ici les CV téléchargés pour les données manquantes ou validez-les par rapport à des candidats similaires.",
            "validate": "Talent existant possible trouvé. Sélectionnez la bonne correspondance ou créez un nouveau talent.",
            "confirm": "Déterminez quel talent vous souhaitez enregistrer et/ou ajouter à une liste d'appels."
         },
         "go-to": "Aller",
         "upload-placeholder": "Glisser-déposer ou parcourir les fichiers",
         "supported-formats": "Formats pris en charge : PDF, DOC, DOCX, ODT, JPG, PNG",
         "save-and-close": "Enregistrer & fermer (continuer plus tard)",
         "review-cvs": "Vérifier les CV",
         "confirm-import": "Importer les candidats",
         "confirm-talents": "Confirmer {count} talent | Confirmer {count} talents",
         "confirm-success": "{created} candidats créés et {updated} mis à jour",
         "confirm-counts": "{new} nouveaux - {updated} mis à jour",
         "selected-count": "{count} sélectionné(s)",
         "review-progress": "{done}/{total} vérifiés",
         "validate-progress": "{done}/{total} validés",
         "mark-as-reviewed": "Marquer comme vérifié",
         "mark-as-to-review": "Marquer comme à vérifier",
         "confirm-and-next": "Confirmer et suivant",
         "bulk-review-success": "{count} CV marqué comme vérifié | {count} CV marqués comme vérifiés",
         "bulk-review-failed": "{count} CV nécessite votre attention | {count} CV nécessitent votre attention",
         "no-docs-to-review": "Aucun CV traité à vérifier pour le moment.",
         "no-duplicates": "Aucun doublon à valider.",
         "select-cvs": "Sélectionner les CV",
         "select-doc": "Sélectionnez un CV dans la liste.",
         "preview-unavailable": "Aucun aperçu disponible pour ce type de fichier.",
         "refined-detection": "Détection affinée",
         "refined-detection-link": "Aller à la détection affinée >",
         "refined-detection-done": "Affinage terminé",
         "refined-detection-unavailable": "La détection affinée n'est pas disponible pour ce CV.",
         "found-in-cv": "Trouvé dans le CV",
         "found-in-nxtpeople": "Trouvé dans NxtPeople",
         "new-talent": "Nouveau talent",
         "pending-docs-warning": "{count} CV nécessite encore une action avant l'importation | {count} CV nécessitent encore une action avant l'importation",
         "processing-docs-warning": "Certains CV sont encore en cours de traitement. Veuillez attendre qu'ils soient prêts avant d'importer.",
         "link-source": "Lier la source au talent",
         "save-in-call-list": "Enregistrer le talent dans une liste d'appels",
         "no-call-list-title": "Aucune liste d'appels sélectionnée",
         "no-call-list-warning": "Vous n'avez pas sélectionné de liste d'appels. Les candidats seront ajoutés à la liste de candidats par défaut.",
         "import-anyway": "Importer sans liste d'appels",
         "doc-status": {
            "to-review": "À vérifier",
            "reviewed": "Vérifié",
            "validate-duplicate": "Valider le doublon",
            "validated": "Validé",
            "completed": "Terminé"
         },
         "tabs": {
            "load": "Charger les CV",
            "review": "Vérifier les CV",
            "validate": "Valider les doublons",
            "confirm": "Confirmer"
         },
         "max-files-warning": "Un maximum de {max} fichiers peut être traité à la fois.",
         "files-rejected": "{count} fichier(s) ignoré(s) (type non pris en charge ou trop volumineux).",
         "upload-failed": "Échec du téléchargement",
         "batch-failed": "Impossible de démarrer le téléchargement",
         "status": {
            "pending": "En attente",
            "uploading": "Téléchargement..",
            "processing": "Traitement..",
            "done": "Prêt",
            "failed": "Échec"
         }
      }
   },
   "communication": {
      "unread-filter": "Afficher uniquement les messages non lus"
   },
   "communications": {
      "actions": {
         "scroll-to-load-messages": "Faire défiler pour charger les messages"
      },
      "all-channels": "Tous les canaux",
      "all-directions": "Toutes les directions",
      "all-teams": "Toutes les équipes",
      "change-team": "Changer l'équipe",
      "channel": "Canal",
      "communication": "Communication | Communications",
      "conversation": "Message | Messages",
      "direction": "Direction",
      "end-of-messages": "Fin des messages",
      "go-to-mail-conversations": "Ouvrir la conversation e-mail avec {name}",
      "go-to-message-conversations": "Ouvrir la conversation SMS/WhatsApp avec {name}",
      "incoming": "Entrant",
      "linked-customer": "Entreprise liée",
      "linked-position": "Offre d'emploi liée",
      "mark-as-read": "Marquer comme lu",
      "mark-as-unread": "Marquer comme non-lu",
      "outgoing": "Sortant",
      "receiver": "Destinataire",
      "search-for-candidate": "Rechercher candidat",
      "search-for-customer": "Rechercher entreprise",
      "search-on-email": "Rechercher par e-mail",
      "search-on-phonenumber": "Rechercher numéro téléphone",
      "sender": "Expéditeur",
      "show-most-recent-message": "Vers le dernier message",
      "type-a-message": "Saisir un message",
      "24-hours-after-last-send-message": "Plus de 24 heures se sont écoulées depuis le dernier message entrant.",
      "click-to-send-as-sms": "Cliquez ici pour envoyer par SMS.",
      "communication-has-been-send-as-type": "Votre message a été envoyé en tant que {type} !",
      "recipients": "Destinataire | Destinataires",
      "bind_number": "Lier les communications",
      "bind-number-modal": {
         "title": "Lier la communication à {type}"
      },
      "no-type-found": "Aucun {type} trouvé pour le numéro de téléphone !",
      "want-to-create-a-new-type": "Souhaitez-vous créer un nouveau {type} ?",
      "sms-character-limit": "Limite de caractères SMS : {limit} caractères"
   },
   "customer": {
      "no-company-results": "Aucun resultat n'a été trouvé. Saisissez un numéro d'entreprise ou un nom pour l'importer!",
      "import-company": "Importer",
      "note-info": "Les notes sont stockées sous l'onglet Activités dans les détails de l'entreprise. \nVous pouvez le changer ou le supprimer par la suite."
   },
   "customers": {
      "activity": "Activité | Activités",
      "add-activity": "Ajouter une activité",
      "add-customer": "Ajouter entreprise",
      "address-deleted": "L'adresse a été supprimée !",
      "addresses": "Adresses d'emploi | Adresses d'emploi",
      "branch-amount": "Nombre d'agences",
      "click-to-go-to-customer": "Cliquez ici pour voir l'entreprise.",
      "closing-date": "Date de clôture",
      "commercial-name": "Nom commercial",
      "company-data": "Les données de la compagnie",
      "company-number": "Numéro d'entreprise",
      "contact-added": "Contact ajouté",
      "contact-deleted": "Le contact a été supprimé !",
      "contacts": "Personne de contact | Contacts | Contacts",
      "customer": "Entreprise | Entreprises",
      "customer-address": "Adresse de la société",
      "customer-created": "La société a été ajoutée",
      "customer-data": "Données client",
      "customer-name": "Nom de l'entreprise",
      "customer-updated": "Entreprise a été modifiée",
      "creditworthiness-warning": "Attention : Ce client a un statut de solvabilité négatif ({credit_worthy_status_name}).",
      "delete-customers": "Supprimer entreprise | Supprimer entreprises",
      "dutch-company-number": "Numéro KVK",
      "dutch-vat-number": "KVK numéro",
      "edit-customer": "Modifier l'entreprise",
      "email-missing": "E-mail est absent",
      "employee-amount": "Nombre d'employés",
      "employment-address": "Adresse d'emploi",
      "employment-region": "Region de travail",
      "founded-at": "Date de fondation",
      "free-edit-text": "Courriel au entreprise",
      "french-company-number": "Numéro de sirène",
      "french-vat-number": "Numéro Siren",
      "interim-amount": "Nombre d'intérimaires",
      "legal-form": "Forme juridique",
      "mail-customers": "Envoyer e-mail à entreprise | Envoyer e-mail aux entreprises",
      "max-amount-customers": "Maximum {amount} customers",
      "nace-code": "Code NACE",
      "name": "Nom",
      "official-name": "Nom officiel",
      "phone-number-missing": "Numéro de téléphone est absent",
      "primary-address": "Siège social | Siège social",
      "sector": "Secteur",
      "select-contact-person": "Sélectionnez contact",
      "spontaneous-application-not-allowed": "Propositions spontanées à cette entreprise ne sont pas autorisées.",
      "spontaneous-application-team-only": "Les propositions spontanées à cette entreprise sont uniquement autorisées pour l'équipe {team}.",
      "spontaneous-application-access": "Proposition spontanée",
      "vat-number": "Numéro d'entreprise",
      "vat-number-error": "{item} invalide!"
   },
   "follow-up": {
      "add-new-status": "Ajouter un nouveau statut",
      "assign-to": "Attribuer",
      "assigned-by": "Assigné par",
      "assigned-to": "Assigné à",
      "by": "à",
      "change-hit": "Modifier match",
      "change-status": "Corriger statut",
      "click-here-to-view-match": "\nCliquez ici pour ouvrir le match",
      "completed": "complété",
      "create-task": "Créer une tâche",
      "created-by": "faite par",
      "delete-hits-description": "Êtes-vous sûr de vouloir supprimer cette correspondance ? \n| \nÊtes-vous sûr de vouloir supprimer ces correspondances ?",
      "delete-match": "Supprimer la correspondance | \nSupprimer les correspondances",
      "description": "description",
      "expired-at": "Expire le",
      "follow-up": "Suivi | Suivis",
      "form-follow-up": "Suivi NxtForm",
      "general": "Général",
      "go-to-matching": "Démarrer une recherche!",
      "spontaneous-application-not-allowed": "Propositions spontanées à cette entreprise ne sont pas autorisées.",
      "hit": "Match | Matches",
      "hit-changed": "Match est modifié",
      "hit-closed": "Fermer match | Fermer matches",
      "hit-created": "Match est créé | Matches sont créé",
      "hit-deleted": "Correspondance supprimée | \nCorrespondances supprimées",
      "hit-filled": "Match est rempli",
      "hit-status-added": "Statut de match ajouté",
      "hit-status-changed": "Statut du match modifié | \nStatuts des matches modifiés",
      "hits-afsluiten": "Fermer matches",
      "mark-as-completed": "Marquer comme terminé",
      "mark-as-incomplete": "Marquer comme incomplet",
      "new-status": "Ajouter prochaine statut",
      "select-application": "Sélectionnez une application",
      "show-completed-tasks": "Afficher les tâches terminées",
      "subject": "Sujet",
      "subject-type": "Type de sujet",
      "task-type": "Type de tâche",
      "tasks": "Tâche | \nTâches",
      "create-hit": "Créer une match",
      "edit-task": "Ajuster la tâche",
      "assign-user": "Assigner utilisateur à une match",
      "attendance": "Présence"
   },
   "general": {
      "no-mails-possible": "Pas de mail possible pour les valeurs sélectionnés",
      "contact-person": "Contact"
   },
   "generic": {
      "access-denied": "Accès interdit",
      "account": "Compte",
      "action-cant-be-undone": "Cette action est irréversible, êtes-vous sûr?",
      "actions": "Actions",
      "active": "Actif",
      "add-contact": "Ajouter contact",
      "add-phone-number": "Ajouter numéro de téléphone",
      "add-to-call-list": "Ajouter à la liste d'appels",
      "addresses": {
         "add-address": "Ajouter adresse",
         "add-employment-address": "Ajouter adresse d'emploi",
         "address": "Adresse",
         "address-added": "L'adresse a été ajoutée",
         "address-updated": "Adresse actualisée",
         "box": "Boite",
         "city": "Ville",
         "country": "Pays",
         "number": "Numéro",
         "postal-code": "Code postal",
         "street": "Rue",
         "update-address": "Modifier adresse d'emploi",
         "use-location": "Utilisez la localisation pour obtenir de meilleurs résultats"
      },
      "again": "À nouveau",
      "all": "Tout",
      "alternative-labels": "Étiquettes alternatives",
      "anonymous": "Anonymement",
      "answer": "Réponse",
      "app-update-status": "De nouvelles fonctionnalités intéressantes sont en cours d'élaboration... Par conséquent, il se peut qu'il y ait un temps d'arrêt le jeudi entre 18 heures et minuit. Nous vous remercions de votre patience pendant la maintenance. Découvrez les nouvelles fonctionnalités plus tard!",
      "application": "Application",
      "appointment-created": "Le rendez-vous <b>{type}</b> avec <b>{name}</b> le <b>{date}</b> a été planifié.",
      "back-to-home-screen": "À l'accueil",
      "based-on-adres": "basé sur l'adresse",
      "body": "Contenu",
      "call": "Cadran",
      "call-later": "Rappelle plus tard",
      "call-registerd": "L'appel est enregistré",
      "can-edit": "Peut personnaliser",
      "change-callList": "Modifier la liste d'appels",
      "change-filters": "Modifier la recherche",
      "direct-search-priority-info": "Vos filtres restent actifs pendant une recherche directe.",
      "characters-left": "{count} caractères restants",
      "choose-year": "Entrez une année précise",
      "clear": "Vider",
      "clear-cache": "Vider le cache",
      "cache-cleared": "Cache vidé",
      "click-here-to-view-the-message": "Cliquez ici pour voir le message",
      "comment": "Remarque",
      "communication": "Communication | Communi-cation",
      "communication-created": "Communication est enregistrée",
      "communication-language": "Langue de communication",
      "communication-via": "Communiquer par",
      "confirm-remove-filter": "Supprimez la recherche {nom}. Cette action est irréversible, êtes-vous sûr ?",
      "confirmation-text": "Texte de confirmation",
      "contact": "Contact",
      "contact-added": "Contact à été ajouté",
      "contact-data": "Coordonnées | Détails du contact",
      "contact-updated": "Le contact a été mis à jour",
      "content": "Contenu",
      "continue-editing": "Continuer la modification",
      "continue-editing-form": "Complétez le formulaire",
      "copied-to-clipboard": "{type} copié !",
      "created-at": "Créé le",
      "customer": "Client | Clients",
      "dates": {
         "date": "Date",
         "day": "Jour | Jours | j",
         "days": {
            "friday": "Ven | Vendredi",
            "monday": "Lun | Lundi",
            "saturday": "Sam | Samedi",
            "sunday": "Alors | Dimanche",
            "thursday": "jeu | Jeudi",
            "tuesday": "mar | Mardi",
            "wednesday": "Mer | Mercredi"
         },
         "end-date": "Date de fin",
         "from": "À partir de",
         "hour": "Heure | Heures | h",
         "month": "Mois | Mois | m",
         "present": "Aujourd'hui",
         "start-date": "Date de début",
         "till": "Jusqu'à",
         "week": "Semaine | Semaines | s",
         "year": "An | Ans | a"
      },
      "delete": "{name} a été supprimé !",
      "delete-file": "Voulez-vous vraiment supprimer le {fileType}?",
      "delete-resume": "Êtes-vous sûr de vouloir supprimer le CV?",
      "deleted-successfully": "{type} a été supprimé !",
      "description": "Description",
      "deselect-all": "Tout déselectionner",
      "diff": "Période d'emploi",
      "direct-search": "Recherche directe",
      "document": "Fichier | Des dossiers",
      "document-type": "Type de document",
      "documents": "Document | Documents",
      "dont-save": "Ne pas enregistrer",
      "drag-file-to-upload": "Faire glisser un fichier pour télécharger",
      "drop-file-here": "Déposez votre (vos) fichier(s) ici!",
      "duration": "Période",
      "edit": "Modifier | {name} modifié!",
      "edit-call-list": "Modifier liste d'appels",
      "edit-filters": "Modifier la recherche",
      "email": "E-mail",
      "event": "Événement",
      "email-send-success": "Les e-mails ont été envoyés.",
      "employer": "Employeur",
      "end": "Fin",
      "erase-filters": "Effacer les filtres",
      "reset-filters": "Réinitialiser les filtres",
      "expire-date": "Date d'expiration",
      "expires-in": "Expire dans",
      "expires-on": "Expire le:",
      "fax": "Télécopieur",
      "feedback": {
         "candidate-selection": "Saisissez une entreprise (et éventuellement une offre d'emploi) pour afficher les options de proposition dans le flux de contact.",
         "communication-preference-warning-description": "Ce candidat ne souhaite pas être contacté par téléphone, êtes-vous sûr de vouloir l'appeler ?",
         "communication-saved": "Communication terminée",
         "customer-selection": "Saisissez un candidat (et éventuellement une offre d'emploi) pour afficher les options de proposition dans le flux de contact.",
         "date-cannot-be-after": "La date ne peut pas être postérieure à {date}",
         "date-cannot-be-before": "La date ne peut pas être antérieure à {date}",
         "down-for-maintenance": "Désolé, nous sommes actuellement en maintenance planifiée !",
         "duplicate-file": "Fichier en double",
         "error": "Quelque chose s'est mal passé !",
         "failed-sms": "{amount} SMS n'ont pas pu être envoyés.",
         "failed-whatsapp": "{amount} messages WhatsApp ne peuvent pas être envoyés.",
         "file-too-large": "Le fichier que vous essayez de télécharger est trop volumineux !",
         "invalid-email": "Cette adresse email n'est pas valide",
         "invalid-url": "Cette url n'est pas valide",
         "invited-for-videocall": "L'invitation à l'appel vidéo a été envoyée",
         "is_qualified": "Admissible",
         "loading": "Charger...",
         "max-filesize": "La taille maximale autorisée pour les fichiers est de {amount}{sizeType}.",
         "max-length": "La longueur maximale est de {value}",
         "max-options": "Maximum {montant} {type}",
         "max-value": "La valeur maximale est {value}",
         "min-length": "La longueur minimale est {value}",
         "min-value": "La valeur minimale est {value}",
         "no-access": "Pas d'accès aux données demandées",
         "no-recipient-with-permission": "Le destinataire ne souhaite pas être contacté via {methode}.",
         "no-results": "Aucun résultat | Aucun résultat",
         "no-valid-language": "Sélectionnez une langue valide",
         "no-valid-recipient": "Veuillez sélectionner un destinataire valide",
         "no-valid-recipients": "Les destinataires ne souhaitent pas être contactés via {methode}.",
         "no-valid-template": "Modèle : \"<strong>{templateKey}</strong>\" est introuvable. \nVérifiez les paramètres du modèle dans Mandrill.",
         "no-valid-template-translation": "Le modèle n'existe pas dans cette langue ({lang}) !",
         "not-qualified": "Non eligible",
         "position-selection": "Saisissez un candidat pour afficher les options de proposition dans le flux de contact.",
         "refresh-to-update": "Une mise à jour est disponible. \nActualisez la page pour installer la mise à jour.",
         "required": "Ce champ est requis",
         "service-unavailable": "Service non disponible!",
         "start-typing-to-search": "Commencez à taper pour rechercher...",
         "sucessful-change-communication": "{amount} messages de communication ont été modifié",
         "sucessful-sms": "Des SMS ont été envoyés.",
         "sucessful-whatsapp": "Messages WhatsApp envoyés",
         "unsaved-changes": "Vous avez des changements non enregistrés",
         "unsaved-changes-description": "Si vous cliquez sur \"supprimer\", toutes les modifications apportées seront perdues. Cliquez sur \"Annuler\" pour continuer l'édition",
         "update-available": "Une mise à jour est disponible.",
         "whatsapp-sent": "Message WhatsApp envoyé",
         "contact-support": "Veuillez contacter notre service d'assistance si le problème persiste",
         "not-allowed": "Vous n'avez aucune quantité aux données demandées",
         "not-found": "Nous n'avons pas pu trouver les données demandées.",
         "validation": "Mauvais pendant la validation des données",
         "file-type-not-allowed": "Le type de fichier n'est pas autorisé!"
      },
      "file-delete-failed": "Quelque chose s'est mal passé! La carte d'identité n'a pas été supprimée!",
      "file-exists": "Un document de type {type} existe déjà. Si vous continuez, le document sera remplacé.",
      "file-name": "Nom de fichier",
      "filter-changed": "La recherche a été modifié",
      "filter-created": "La recherche a été ajoutée",
      "filter-important": "Marquer le filtre comme important",
      "filter-info": "Combine les mots-clés avec:<br>\n<strong>OR</strong>: un des mots-clés doit apparaître dans le résultat.<br>\n<strong>AND</strong>: tous les mots-clés doivent apparaître dans le résultat.<br>\n<strong>NOT</strong>: le mot-clé ne doit pas apparaître dans le résultat. p.ex.: NOT master<br>\n<strong>?</strong>: pour prendre en compte différents ortographes. p.ex.: controll??r.<br>\n<strong>\"\"</strong>: pour chercher un mot exact ou pour définer 2 mots ensemble. p.ex.: \"Le Soir\".<br>",
      "filter-less-important": "Marquer le filtre comme moins important",
      "filter-removed": "La recherche a été supprimée",
      "filters": "Rechercher | \nRecherches",
      "fiscal-data": "Données fiscales",
      "form": {
         "next": "Suivante",
         "previous": "Précédent",
         "select": "Sélectionnez | Sélectionner {type}",
         "missing-data": "Données manquantes: Compléte {properties}"
      },
      "free-text": "Texte libre",
      "function-category": "Catégorie de fonction",
      "function-data": "Données de fonction",
      "general": "Général",
      "general-data": "Données générales",
      "give-call-list-a-name": "Nommez votre liste d'appels",
      "give-filter-a-name": "Donnez un nom à votre recherche",
      "global-videocall-url": "URL de la plateforme d'appel vidéo",
      "global-videocall-url-info": "Entrez ici l'url qui conduira les utilisateurs à la plateforme d'appel vidéo. Cela sera visualisé dans le formulaire de contact. Les urls des différentes salles peuvent être définies pour chaque équipe via la liste ci-dessous.",
      "how-do-you-wish-to-mail": "Comment souhaitez-vous envoyer ce message?",
      "how-do-you-wish-to-send": "Comment souhaitez-vous envoyer?",
      "id": "ID",
      "id-card": "Carte d'identité",
      "identity": "Identité",
      "important": "Important",
      "inactive": "Inactif",
      "in-office": "Au bureau",
      "include_job_distances": "Inclure région de travail",
      "included": "Inclus | {type} inclus",
      "incoming-call-from": "Appel entrant de <b>{name}</b>",
      "interested": "Intéressé",
      "internal-comment-with-appointment": "Note interne sur rendez-vous",
      "internal-information": "information interne",
      "is-graduated": "Réussi",
      "all-functions": "Tout les fonctions",
      "job-functions": "Fonction professionnelle",
      "languages": "Langue | Langues",
      "last-editted": "Dernière modification",
      "leave-page": "Êtes-vous sûr de vouloir quitter la page ?",
      "leave-page-description": "Lorsque vous quittez la page, toutes les modifications seront supprimées. Êtes-vous sûr de vouloir quitter la page ?",
      "less-important": "Moins important",
      "loading-items": "Chargement de {results} sur {resultTotal} résultats",
      "location": "Situation",
      "mail": "E-mail",
      "mail-editors": {
         "mail-candidate-to-customer": "Envoyer candidat à l'entreprise par e-mail",
         "mail-candidate-to-team": "Envoyer le candidat à l'équipe",
         "mail-positions-to-candidates": "Envoyer des offres d'emploi aux candidats"
      },
      "mail-to": "Courrier à",
      "match": "Match",
      "max": "Max | Maximum",
      "min": "Min | Minimum",
      "must-meet-all-parameters": "Doit répondre à tous les paramètres.",
      "must-meet-one-parameter": "Doit répondre à l’un des paramètres.",
      "my-contact-data": "Mes coordonnées",
      "my-filters": "Mes recherches",
      "name": "Nom | Noms",
      "no": "Non",
      "no-delete-permission": "Aucun droits de suppression",
      "no-journey-selected": "Veuillez sélectionner un Journey pour continuer !",
      "no-results-for-tenant": "Aucune {type} n'a été trouvée pour cette recherche!",
      "no-roles-assigned": "Aucun droit de {module} n'a été attribué à votre compte. Contactez un administrateur pour obtenir les permissions nécessaires.",
      "no-url-provided": "Aucune URL fournie, fermez le modal et réessayez !",
      "no-voip-found": "Pas de VOIP trouvé pour l'utilisateur",
      "none": "Non",
      "not-passed": "Pas réussi",
      "note": "Note",
      "notification": "Notification | Notifications",
      "off": "Off",
      "office": "Bureau",
      "on": "On",
      "one": "un",
      "only-this-hit": "Juste ce match",
      "open-mail-editor": "Ouvrir l'éditeur de messagerie",
      "optional": "Optionelle",
      "organisation": "Organisation",
      "other": "Autre",
      "passed": "Réussi",
      "per": "Par",
      "personal": "Personnel",
      "phone": "Appel | Sonner",
      "phone-number-invalid": "La valeur entrée n'est pas un numéro de téléphone valide!",
      "phone-number-invalid-country": "Le pays sélectionné est invalide!",
      "phone-number-nan": "Numéro de téléphone n'est pas un nombre!",
      "phone-number-primary": "Numéro de téléphone (principal)",
      "phone-number-too-long": "Numéro de téléphone est trop long!",
      "phone-number-too-short": "Numéro de téléphone est trop court!",
      "phone-numbers": "Numéro de téléphone | Numéros de téléphone",
      "phone-numbers-primary": "Numéro de téléphone (principal)",
      "plan-appointment": "Planifier rendez-vous",
      "preview": "Exemple",
      "profile": "Profil",
      "profile-of-candidate-is-empty": "Le profil de ce candidat est vide",
      "progressing": "En cours",
      "propose-candidate-to-customer": "présentation candidat à l'entreprise",
      "propose-position": "Présent poste vacant",
      "propose-to-customer": "Présent à l'entreprise",
      "propose-to-description": "Après validation, une match sur le statut <strong>'{proposeTo}'</strong> sera créé.<br>Notez pourquoi ce candidat convient à ce poste vacant.",
      "propose-to-team": "Présenter à l'équipe",
      "propose-to-team-description": "Après validation, une match sur le statut <b>Présentation candidat à l'équipe</b> sera créée pour l'équipe de l'offre d'emploi.",
      "propose-to-team-description-no-position": "Après validation, une match sur le statut <b>Présentation candidat à l'équipe</b> sera créée pour l'équipe responsable.",
      "proposition": "proposition",
      "proposition-created": "<b>{name}</b> avec le statut <b>{status}</b> a été ajouté.",
      "publish": "Publier",
      "put-in": "Entre",
      "query-to-clipboard": "Recherche copiée",
      "question": "Question",
      "radius": "Rayon",
      "reason": "Raison",
      "reference": "Référence",
      "refresh-results": "Actualiser résultats",
      "registration": "Inscription",
      "reminder-created": "{type} Un <b>Rappel</b> avec <b>{name}</b> le <b>{date}</b> a été prévu.",
      "remove-callList": "Supprimer liste d'appels",
      "remove-filters": "Supprimer la recherche",
      "remove-selected-filters": "Supprimer le(s) filtre(s) sélectionné(s).",
      "removed-selected-filters": "{amount} filtre(s) sélectionné(s) ont été supprimés",
      "restore-deleted-filters": "Réinitialiser le(s) filtre(s) sélectionné(s).",
      "restored-deleted-filters": "{amount} filtre(s) sélectionné(s) ont été réinitialisés",
      "results": "Résultat | Résultats",
      "resume-type": "Type de CV",
      "salutation": "Civilité",
      "save-call-list": "Enregistrer liste d'appels",
      "save-callList": "Enregistrer liste d'appels",
      "save-filters": "Enregistrer la recherche",
      "saved-searches": "Recherches enregistrées",
      "scheduled-at": "Prévu à",
      "score": "Score",
      "select-all": "Tout sélectionner",
      "select-date-and-time": "Choisissez une date et une heure",
      "select-position": "Choisissez une offre d'emploi",
      "select-videocall-room": "Sélectionnez une salle d'appel vidéo",
      "selected": "Choisi",
      "send": "Envoyer | Envoyer",
      "send-appointment-via": "Envoyez rendez-vous via",
      "send-blind-copy": "Envoyer en Cci",
      "send-copy": "Envoyer CC",
      "send-NxtJourney": "Envoyer NxtForm journey",
      "send-resume-via": "Envoyer le type de CV",
      "send-sms": "Envoyer un SMS | Envoyer des SMS",
      "send-videocall-invite": "Inviter à un appel vidéo",
      "send-whatsapp": "Envoyer un message WhatsApp",
      "share-call-list": "Partagez votre liste d'appels",
      "share-filters": "Partagez votre recherche",
      "shared-with-me": "Partagé avec moi",
      "show-less-filters": "Afficher moins de filtres",
      "show-more": "Montre plus",
      "show-more-filters": "Afficher plus de filtres",
      "size": "Taille du fichier",
      "sms": "Message texte",
      "sms-content": "Contenu de SMS",
      "sms-sent": "Le SMS a été envoyé | SMS ont été envoyés",
      "something-went-wrong": "Quelque chose s'est mal passé",
      "something-went-wrong-description": "Quelque chose a mal tourné lors de la récupération des données essentielles. Pour revenir à l'écran d'accueil, cliquez sur le lien ci-dessous. Si le problème persiste, contactez votre administrateur système.",
      "specific-unit-videocall": "Salles d'appel vidéo spécifiques à l'unité",
      "spontaneous-propose-candidate-to-customer": "Présenter spontanée à l'entreprise",
      "spontaneous-propose-to-customer": "Présenter spontanée à l'entreprise",
      "status": "Statut",
      "subject": "Sujet",
      "template": "Modèle",
      "template-does-not-support-language": "Le modèle ne prend pas en charge cette langue.",
      "this-action-cannot-be-undone": "Cette action ne peut pas être annulée.",
      "title": "Titre",
      "to": "À",
      "transport": "Transport",
      "type": "Type | Les types",
      "u-have-no-access": "Pas de permission pour voir cette page",
      "updated-at": "Mis à jour à",
      "upload-date": "Date de dépôt",
      "url-copied": "URL copiée",
      "validate": "Valider",
      "variables": "Variables",
      "verification-requested": "La demande de vérification a déjà été envoyée au candidat",
      "verified-on": "Vérifié le: {dateTime}",
      "verify": "Vérifier",
      "verify-again": "Vérifier à nouveau les données",
      "via": "Via",
      "videocall": "Appel vidéo",
      "videocall-change": "Personnaliser l'appel vidéo",
      "videocall-meeting": "Videocall meeting",
      "videocall-room": "Salle d'appel vidéo | \nSalles d'appel vidéo",
      "videocall-room-added": "Salle d'appel vidéo ajoutée!",
      "videocall-room-changed": "La salle d'appel vidéo a été mise à jour!",
      "videocall-room-removed": "La salle d'appel vidéo a été supprimée!",
      "website": "Site Internet",
      "what-do-you-want-to-send": "Que souhaitez-vous envoyer?",
      "whatsapp": "WhatsApp",
      "whereby-embedded-not-available": "Whereby n'est pas disponible pour : {type} !",
      "whereby-room": "Whereby room",
      "work-situation": "Situation professionnelle",
      "yes": "Oui",
      "closest-team-option": "Équipe la plus proche",
      "kilometer": "Kilomètre | kilomètres",
      "saved-search": "Recherche enregistrée",
      "account-not-found-description": "Nous n'avons pas trouvé votre compte dans ce module",
      "exception": "Exception | Exceptions",
      "limit": "Limite | Limites",
      "no-document-found": "Aucun document trouvé",
      "pin-activity": "Épingle",
      "unpin-activity": "Desserrer",
      "global": "Mondial",
      "unlimited": "Illimité",
      "publication-data": "Détails de publication",
      "extra": "Supplémentaire",
      "show-result": "Montrer le résultat",
      "job-distances-included": "",
      "warning": "Note!",
      "nxt-jobs": "Nxtjobs",
      "last-update": "Dernière mise à jour",
      "relevance": "Pertinence",
      "take-offline-action": "Mettre hors ligne",
      "take-offline-notification": "Demande de mise hors ligne envoyée",
      "take-offline-not-allowed": "Vous n'avez pas accès pour mettre l'offre d'emploi hors ligne",
      "modify-status-action": "Modifier statut",
      "modify-status-notification": "Statut modifié",
      "modify-status-not-allowed": "Vous n'avez pas accès pour modifier l'offre d'emploi",
      "recently-graduated": "Diplômé récent",
      "recently-graduated-description": "Candidat a terminé avec succès une étude au cours des 3 derniers mois",
      "communication-preferences": "Préférences de communication",
      "update-action": "Action de mise à jour"
   },
   "matching": {
      "match": "Match | Matching",
      "select-source": "Choisissez un {sourceType}",
      "source-type": "Source",
      "switch-target-source": "Échanger source et cible",
      "target-type": "Cible",
      "show-type-details": "Afficher les détails de {type}"
   },
   "positions": {
      "activity": "Activité | Activités",
      "accepted-answer": "Réponse souhaitée",
      "add-position": "Ajouter une offre d'emploi",
      "add-referral-code": "Ajoutez un code de référence",
      "advertsdata": "Offres d'emploi Google",
      "application-url": "URL de l'application",
      "apply": "Postuler",
      "apply-via": "Postuler via",
      "auto-repost": "Reprise-auto",
      "available-languages": "Langues disponibles",
      "can-be-visible-in-app": "Afficher dans app",
      "can-take-up-to-a-minute": "Génération de texte ! \n| \nNe vous inquiétez pas, nous aurons fini avant que vous ne le sachiez ! \n| \nNous avons presque terminé, alors accrochez-vous !",
      "chatGPT": {
         "almost-done": "Nous sommes presque finis, donc gardez la foi!",
         "busy-generating-text": "Génération de texte",
         "dont-worry": "Ne vous inquiétez pas, nous serons prêts avant que vous le sachiez!"
      },
      "click-to-go-to-match": "Montrer match",
      "click-to-go-to-position": "Cliquez ici pour accéder à l'offre d'emploi",
      "comma-separated": "séparés par des virgules",
      "copy-position": "Copier l'offre d'emploi",
      "create-in-nxtmatch": "Créér dans NxtMatch",
      "date-of-creation": "Date de création",
      "delete-positions": "Supprimer offre d'emploi | Supprimer offres d'emploi",
      "edit-position": "Modifier l'offre d'emploi",
      "edit-website-status": "Modifier publication sur site web",
      "form-disabled": "Non disponible pour les postes vacants externes",
      "function-level": "Niveau de fonction",
      "function-title": "Fonction de l'emploi",
      "generate": "Générer",
      "generate-automatic-text": "Générer texte automatique",
      "generate-automatic-text-info": "En fonction de l'intitulé du poste saisi, un texte d'offre d'emploi approprié sera généré dans la langue choisie. Vérifiez ce texte et ajustez-le en fonction des conditions convenues.",
      "generation-error": "Impossible de générer du texte pour le fonction de l'emploi saisi!",
      "gross-wage": "Salaire brut",
      "internal-contact": "Personne de contact interne | Personne de contact interne",
      "job-type": "Type d'emploi",
      "job-types": "Type d'emploi",
      "journey-referral": "Jounrey référence",
      "journey-referral-code-not-found": "Le code de parrainage Journey \"nxt-match\" est introuvable!",
      "keywords": "Mots-clés",
      "knockout-questions": "Question éliminatoire | Questions éliminatoires",
      "location-search-info": "Recherche par adresse d'entreprise. Celle-ci peut différer de l'adresse de travail indiquée dans le poste vacant.",
      "mail-position": "E-mail d'offre d'emploi",
      "matches": "Matches",
      "max-10-positions": "Maximum 10 offres d'emploi",
      "modify-status": "Vous êtes sûr de changer le statut?",
      "no-delete-position-permission": "Aucune autorisation pour supprimer ce poste vacant",
      "no-published-position-selected": "Aucune offre publiée sélectionnée",
      "not-visible-in-app": "Offre d'emploi n'est pas visible dans app",
      "number-of-persons-wanted": "Nombre de personnes recherchées",
      "online": "Offres d'emploi en ligne",
      "only-open-position-published": "Seuls les offres d'emploi ouverts peuvent être publiés.",
      "open-position": "Ouvrir poste vacant NxtMatch",
      "people-needed": "Nombre de candidats toujours recherchés",
      "please-choose-customer": "Choisissez d'abord une entreprise",
      "position": "Offre d'emploi | Offres d'emploi",
      "position-closed": "Offre d'emploi est déjà fermé",
      "position-created": "Offre d'emploi a été ajouté",
      "position-edited-and-online": "Le poste est publié mais a été modifié !",
      "position-offline": "Offre d'emploi n'est pas publiée",
      "position-publish-failed": "L'offre d'emploi {title} ne peut être publié en ligne en raison d'une erreur",
      "position-published-edit-disabled": "L'offre d'emploi est publié et ne peut pas être modifié",
      "position-put-offline": "L'offre d'emploi {title} est hors ligne",
      "position-put-online": "L'offre d'emploi {title} est en ligne",
      "position-taken-offline": "Ce le statut est modifié, la publication sera mise hors ligne.",
      "position-updated": "La vacance a été modifiée",
      "processing": "En cours...",
      "publication": "Publication | publications",
      "publication-data": "Données de publication",
      "creation-date": "Date de création",
      "publication-date": "Date de publication",
      "publication-sites": "Site Web de publication | \nSites Web de publication",
      "nxtjob-sites": "NxtJob website | NxtJob websites",
      "publications": {
         "no-results": "Aucune publication trouvée!"
      },
      "put-offline": "Hors ligne",
      "put-online": "En ligne",
      "referral-code-doesnt-match-with-nxt-match": "Code de référence NxtMatch est introuvable ou ne correspond pas à l'équipe.",
      "refresh-journey": "Rafraîchir le journey",
      "remove-language-confirmation-message": "Êtes-vous sûr de vouloir supprimer cette langue ? Cette action ne peut pas être annulée!",
      "remove-language-confirmation-title": "Êtes-vous sûr de vouloir supprimer cette langue ?",
      "required-attributes-missing": "Veuillez remplir {attributes}",
      "translate-source-badge": "Source",
      "set-as-source": "Définir {language} comme langue source",
      "set-as-source-info": "{language} devient la nouvelle source des traductions",
      "translate-from-source": "Traduire de {source} vers {target}",
      "translate-from-source-info": "Écrase tout le contenu {target}",
      "translate-source-to-all": "Traduire la source vers toutes les langues",
      "translated-language": "{language} a été traduit automatiquement",
      "translate-overwrite-title": "Traduire à partir de {source}",
      "translate-overwrite-message": "Le contenu existant sera remplacé par la traduction automatique.",
      "translation-error": "La traduction a échoué. Veuillez réessayer plus tard.",
      "switch-source-warning": "Changer la langue source peut écraser le contenu existant lors de la traduction.",
      "remove-language": "Supprimer {language}",
      "remove-language-info": "Tout le contenu pour {language} sera effacé",
      "startup-date": "Date de démarrage",
      "summary-description-info": "Ce contenu est utilisé comme texte d'introduction dans le app et sur les sites d'emploi qui le prennent en charge.",
      "title": "Titre du poste",
      "user-spoc": "SPOC",
      "visible-in-app": "Offre d'emploi est visible dans app",
      "wage": "Salaire",
      "wage-max": "Salaire brut maximum",
      "wage-min": "Salaire brut minimum",
      "wage-type": "Type de salaire brut",
      "wage-view": "Affichage salaire brut",
      "wage-view-on-website": "Affichage du salaire brut sur site web",
      "website-status": "Statut de publication",
      "website_url": "URL de site web",
      "young-talent": "Young talent",
      "hours-per-week": "Heures par semaine",
      "visible-in-nxt-job": "Show in NxtJob",
      "external-publication": {
         "external-publication": "Publication externe",
         "failed-to-load": "Les technologies de recrutement n'ont pas pu être chargées"
      },
      "recruit-anywhere": {
         "recruit-anywhere": "RecruitAnywhere"
      },
      "internal-publication": {
         "internal-publication": "Publication interne",
         "nxt-job-board": "NxtJob board | NxtJob boards",
         "show-in-app": "Afficher dans l'application",
         "show-in-nxt-job": "Show in nxtJob"
      },
      "tile-image": "Image vacant",
      "position_does_not_belong_to_default_team": "Le poste vacant n'appartient pas à l'équipe actuelle"
   },
   "reporting": {
      "reporting": "Rapports"
   },
   "settings": {
      "add-automatic-message": "Ajouter un message automatique",
      "add-target-group": "Ajouter groupe cible",
      "application-settings": "Paramètres de l'application",
      "applied-default-filters": "Filtres par défaut appliqués pour {name}",
      "applied-target-group-filters": "Audiences appliquées pour {name}",
       "automatic-message-delete": "Supprimer le message automatique ?",
       "automatic-message-deactivated-at": "Désactivé automatiquement le {date}",
       "automatic-message-deactivation-inactive_journey": "Le parcours lié est inactif",
       "automatic-message-deactivation-limit_reached": "La limite de messages a été atteinte",
       "automatic-messages": "Message automatique | \nMessages automatiques",
      "available-filters": "Filtres disponibles",
      "available-target-groups": "Audiences disponibles",
      "data": "Rendez-vous",
      "default-filters": "Filtres par défaut",
      "developer": "Développeur",
      "filter-on-priority": "Filtrer par priorité",
      "has-custom-settings": "Contient différents paramètres",
      "is-mandatory": "Obligatoire pour postuler ?",
      "mandrill-template": "Gabarit de mandrin",
      "name-target-group": "Nom du public",
      "no-filters-selected": "Aucun filtre par défaut n'a encore été ajouté pour ce groupe d'équipe. \nCliquez sur un ou plusieurs filtres disponibles dans la liste et ajoutez-les avec le bouton orange.",
      "no-target-group-filters-selected": "Aucun groupe cible n'a encore été ajouté. Cliquez sur un ou plusieurs groupes cibles disponibles dans la liste pour les ajouter.",
      "no-target-groups-for-target-type": "Aucune audience n'a encore été ajoutée pour ce type d'audience.",
      "priority": "Priorité | \nPriorités",
      "push-default-filters-to-teams": "Ce cluster contient une ou plusieurs équipes contenant des filtres standard différents. \n{cliquez} pour appliquer les paramètres de cluster dans ces équipes.",
      "push-target-group-filters-to-teams": "Ce cluster contient une ou plusieurs équipes qui contiennent différents groupes cibles. \n{cliquez} pour appliquer les paramètres de cluster dans ces équipes.",
      "remove-from-list": "Retirer de la liste",
      "reset-team-default-filter-settings": "Cette équipe contient différents filtres par défaut selon le cluster parent. \n{click} pour restaurer les filtres par défaut du cluster.",
      "reset-team-target-group-filter-settings": "Cette équipe contient différents groupes cibles selon le cluster parent. \n{click} pour reprendre les groupes cibles du cluster.",
      "saved-cluster-settings": "Paramètres du cluster sauvegardés",
      "saved-team-settings": "Paramètres de l'équipe sauvegardés",
      "settings": "Paramètre | Paramètres",
      "settings-for": "Paramètres pour {nom}",
      "target-group": "Groupe cible | Groupes cibles",
      "target-group-filter-edited": "Le groupe cible a changé",
      "target-group-filter-saved": "Le groupe cible a été créé",
      "target-type": "Type de cible",
      "teams-without-cluster": "Équipes sans groupe d'équipe",
      "unlock-team-default-filter-settings": "Les filtres par défaut du cluster parent sont appliqués. \n{cliquez} pour activer des filtres par défaut différents pour cette équipe.",
      "unlock-team-settings": "Les paramètres du cluster parent sont appliqués. {click} pour activer paramètres différents pour cette équipe.",
      "unlock-team-target-group-filter-settings": "Les groupes cibles du cluster parent sont appliqués. \n{cliquez} pour activer différents groupes cibles pour cette équipe.",
      "zoom": "Agrandir",
      "cache-settings": "Données en cache",
      "incoming-messages": "Messages entrants",
      "responsible-team-for-incoming-messages": "Équipe responsable des messages provenant de numéros inconnus",
      "automatic-message-limit": "Limite automatique des messages",
      "automatic-message-has-limit": "A une limite",
      "max-communications-per-user": "Limites de communications sortantes par semaine",
      "max-sms": "Limite de SMS",
      "max-whatsapp": "Limite WhatsApp",
      "max-email": "Limite de courrier électronique",
      "communication-exception-must-have-limits": "L'exception doit avoir une limite définie !",
      "communication-exception-must-have-limits-description": "Entrez l'une des limites, SMS, WhatsApp ou e-mail pour l'enregistrer.",
      "amount-messages-sent": "{amount} messages envoyés",
      "empty-user-limit": "Veuillez définir au moins une limite ou supprimer l'élément sélectionné.",
      "job-board-url": "URL",
      "job-board-name": "Nom de NxtJob page",
      "show-details": "Montrer les détails",
      "hide-details": "Masquer les détails",
      "interface-scale": "Taille de l'interface",
      "intro-text": "Loisirs",
      "header-background-color": "En-tête de couleur d'arrière-plan",
      "header-font-color": "En-tête de couleur texte",
      "position-card-color": "Carreaux de vacance de couleur d'arrière-plan",
      "text-color": "Carreau de vacance de couleur de texte",
      "header-image": "En-tête d'image",
      "logo-image": "Logo",
      "vdab": "VDAB",
      "notification-email": "Adresse électronique de notification des demandes de suppression",
      "merger": "Fusion de candidats",
      "last-updated": "Dernière mise à jour",
      "initial_candidate": "Candidat initial",
      "duplicate_candidate": "Candidat en double",
      "initial-candidate": "Candidat initial",
      "duplicate-candidate": "Candidat en double",
      "merge": "Fusionner",
      "only-deleted-searches": "Afficher uniquement les recherches supprimées"
   },
   "tasks": {
      "assign-user": "Attribuer un utilisateur à une tâche",
      "click-to-go-to-task": "Aller à la tâche",
      "remove-assigned-user": "Supprimer l'utilisateur attribué"
   },
   "teams": {
      "employer": "Employeur | Employeurs",
      "no-team-email": "Cette équipe n'a pas d'email !",
      "no-teams-selected": "Aucune équipe(s) sélectionnée(s) pour le moment",
      "team": "Équipe | Équipes",
      "team-address": "Adresse de l'équipe",
      "team-name": "Nom de l'équipe"
   },
   "user-info": {
      "internal-job-function": "Fonction",
      "log-out": "Se déconnecter",
      "user-settings": "Paramètres utilisateur",
      "voip": "VoIP"
   },
   "users": {
      "no-users-selected": "Aucun utilisateur sélectionné",
      "user": "Utilisateur | Utilisateurs"
   },
   "error": {
      "user_no_country_set": "L'équipe de l'utilisateur n'a pas de pays !",
      "user_no_country_set_message": "Veuillez contacter un administrateur !"
   },
   "errors": {
      "error": "Erreur | Erreurs",
      "account-not-found": "Ce compte est inconnu."
   }
}
